export default {
  SaveData: 'SaveData',
  SaveNotif: 'SaveNotif',
  AddData: 'AddData',
  SaveApiResMessage: 'SaveApiResMessage',
};
